/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NegotiationAliases {
  CARD_NEGOTIATION = 'card-negotiation',
  CONTEXTUAL_BAR_NEGOTIATION = 'contextual-bar-negotiation',
  DECK_NEGOTIATION = 'deck-negotiation',
  FETCH_NEGOTIATION = 'fetch-negotiation',
  FIELD_NEGOTIATION = 'field-negotiation',
  FIELD_PROPONENT = 'field-proponent',
  PANEL_NEGOTIATION = 'panel-negotiation',
  TEXT_NEGOTIATION = 'text-negotiation',
  TEXT_PROPONENT = 'text-proponent',
}
export { NegotiationAliases };
